//
//
//
//
//
//
//
//

export default {
  name: "noData",
  props: {
    width: {
      default: "200px",
      type: String
    },
    height: {
      default: "100px",
      type: String
    }
  }
};